import { render, staticRenderFns } from "./AiffectChain.vue?vue&type=template&id=9f250804&scoped=true"
import script from "./AiffectChain.vue?vue&type=script&lang=js"
export * from "./AiffectChain.vue?vue&type=script&lang=js"
import style0 from "./AiffectChain.vue?vue&type=style&index=0&id=9f250804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f250804",
  null
  
)

export default component.exports